import { Component, TemplateRef, ViewChild } from '@angular/core';
import { User } from 'src/app/models/user';
import { first } from 'rxjs/operators';
import { catchError, throwError } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule, TranslateModule]
})
export class ProfileComponent {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";
  showPasswordNew: boolean = false;
  showPasswordOld: boolean = false;
  showPasswordCnfrm: boolean = false;
  // lastLoggedInAtIST: Date;
  changePass: boolean = false;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;

  currentUser: User = new User();
  licenseData: any;
  lastLoginTime: string;
  istTime: string;

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private router: Router,

    private dialog: MatDialog
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    // this.getLicenseInfo();
    this.lastLoginTime = localStorage.getItem('lastLoggedInTime');
    this.convertToIST();

  }

  getLicenseInfo() {
    this.userService.getLicenseInfo(this.currentUser.licenseId).pipe(first()).subscribe((response: any) => {
      this.licenseData = response.data.data;
    })
  }
  convertToIST() {
    const gmtDate = new Date(this.currentUser.userObj.lastLoggedInAt);
    const istOffset = 5.5; // IST is GMT+5:30
    const istTimeInMillis = gmtDate.getTime() + (istOffset * 60 * 60 * 1000);
    const istDate = new Date(istTimeInMillis);
    this.istTime = istDate.toISOString().slice(0, 19).replace('T', ' '); // Format as 'yyyy-MM-dd HH:mm:ss'

  }
  openchangepass() {
    this.changePass = !this.changePass;
  }

  onSave() {
    if (this.confirmPassword != this.newPassword) {
      this.msg = "Both passwords don't match!";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert("Both passwords don't match !")
    }
    else {
      if (this.newPassword.length > 8) {
        this.userService.changePass(this.currentUser.userObj.email, this.newPassword, this.oldPassword)
          .pipe(
            first(),
            catchError((error: HttpErrorResponse) => {
              // Log the error message
              console.error('Error occurred:', error);

              // Check if the error message matches the condition
              if (error.error && error.error.status === 'Entered password same as current password') {
                // Show modal here
                this.msg = "Entered password same as current password";
                this.openAlertMod(this.alertTemplate, this.msg);
                // alert("Entered password same as current password");
              }
              if (error.error.description == "Forbidden: Invalid email or password") {
                this.msg = "Invalid email or password";
                this.openAlertMod(this.alertTemplate, this.msg);
                // alert("Invalid email or password");
              }


              return throwError(error);
            })
          )
          .subscribe((res: any) => {
            if (res.success == true) {
              this.msg = "Password updated successfully!";
              this.openAlertMod(this.alertTemplate, this.msg);
              // alert("Password updated successfully!");
              this.changePass = !this.changePass;
              let user = new User();
              user = this.currentUser;
              sessionStorage.removeItem('currentUser');
              this.loginService.setcurrentUserSubject(null);
              this.router.navigate(['/login']);
            }
            if (res.success == false) {
              this.msg = res.description;
              this.openAlertMod(this.alertTemplate, this.msg);
              // alert(res.description);
            }
          });
      }
      else {
        this.msg = "Password must be of length >8";
        this.openAlertMod(this.alertTemplate, this.msg);
        // alert("Password must be of length >8")
      }
    }
  }
  togglePasswordVisibilityNew() {
    this.showPasswordNew = !this.showPasswordNew;
  }
  togglePasswordVisibilityOld() {
    this.showPasswordOld = !this.showPasswordOld;
  }
  togglePasswordVisibilityCnfrm() {
    this.showPasswordCnfrm = !this.showPasswordCnfrm;
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = '';
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

}
